import { useValidations } from "@sttedra_ui/framework";

const { required } = useValidations();

export default function () {
  return {
    items: [
      {
        field: "email",
        label: "Correo electrónico",
        value: null,
        rules: { required },
        classObj: ["col-12"],
      },
    ],
  };
}
